const storedFiles = new Map<string, FileList>();

export const storeFiles = (fieldName: string, files: FileList | null) => {
  if (files && files.length > 0) {
    storedFiles.set(fieldName, files);
  } else {
    storedFiles.delete(fieldName);
  }
};

export const getStoredFiles = (fieldName: string): FileList | null => {
  return storedFiles.get(fieldName) || null;
};

export const clearStoredFiles = (fieldName: string) => {
  storedFiles.delete(fieldName);
};
